import * as CONSTANTS from './OrderActionConstants'
let initialState = {

    fetchOrderHistoryInProgress: false,
    fetchOrderHistoryInComplete: false,
    fetchOrderHistoryInFailed: false,
    orderHistory: [
 
    ]
}
const createSchoolInformationReducer = (state = initialState, action) => {
    switch (action.type) {
        case CONSTANTS.FETCH_ORDER_HISTORY_IN_PROGRESS:
            return { ...state, fetchOrderHistoryInProgress: true, fetchOrderHistoryInFailed: false, fetchOrderHistoryInComplete: false };
        case CONSTANTS.FETCH_ORDER_HISTORY_COMPLETE:
            return { ...state, fetchOrderHistoryInProgress: false, fetchOrderHistoryInComplete: true, orderHistory: action.data };
        case CONSTANTS.FETCH_ORDER_HISTORY_FAILED:
            return { ...state, fetchOrderHistoryInProgress: false, fetchOrderHistoryInFailed: true};
        default:
            return state;
    }


}
export default createSchoolInformationReducer;